// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {useContext, useState, Fragment} from 'react';
import cn from 'classnames';
import styles from './accordion.module.less';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../shared/button';
import Icon_chevron_down from '../img/svg/icon/chevron_down.svg';

interface i_question_props {
    question: string;
    answer: string;
}
interface i_faq_section_props {
    items: i_question_props[];
    cols?: number;
    cls?: string;
}

const Question = (props: i_question_props)=>{
    const {theme} = useContext(Settings_context);
    const [opened, set_opened] = useState(false);
    return <div className={cn(styles.faq_item, opened && styles.opened)}>
      <div className={cn(styles.title_line)} onClick={()=>{
        set_opened(!opened);
      }}>
        <p className={cn(theme.p2, theme.med, styles.question)}>
          {props.question}
        </p>
        <Icon_chevron_down/>
      </div>
      <div className={cn(styles.faq_text)}>
        <p className={cn(theme.p3, theme.reg)}>{props.answer}</p>
      </div>
    </div>;
};

export const Accordion = ({items, cols=1, cls}:
    i_faq_section_props)=>{
    const {theme} = useContext(Settings_context);
    const qa_cols = items.reduce((acc, q, i)=>{
        const current = i % cols;
        if (!acc[current])
            acc[current] = [];
        acc[current].push(q);
        return acc;
    }, []);
    return <div className={cls}>
      <div className={cn(theme.container, styles.content)}>
        <div className={styles.faq_questions}>
          {qa_cols.map((col_qa, col_i)=>
            <div className={styles.faq_questions_col} key={col_i}>
              {col_qa.map((q, i)=><Question key={i}
                question={q.question} answer={q.answer}/>)}
            </div>)}
        </div>
      </div>
    </div>;
};

interface i_accordion_editor_props {
    value: i_faq_section_props;
    on_change: (value: i_faq_section_props)=>void;
}

export const Accordion_editor = (props: i_accordion_editor_props)=>{
    const {value, on_change} = props;
    const [state, set_state] = useState(value);
    return <Editor value={state}
      on_change={v=>{
        on_change(v);
        set_state(v);
      }} on_save={()=>on_change(state)}
      editors={[
        {key: 'cls', label: 'CSS class (optional)', type: 'text'},
        {key: 'cols', label: 'Columns (optional)', type: 'number'},
      ]}>
      <Fragment>
        {state.items.map((item, i)=><div key={i}>
          <Editor value={item}
            editors={[
              {key: 'question', label: 'Question', type: 'text'},
              {key: 'answer', label: 'Answer', type: 'text'},
            ]}
            on_change={qa=>{
              const new_items = [...state.items];
              new_items[i] = qa;
              set_state({...state, items: new_items});
            }}/>
          <Button caption="Delete item" size="xs"
            on_click={()=>{
              set_state({
                ...state,
                items: state.items
                  .filter((_, index)=>index!==i)
              });
            }}/>
          <hr/>
        </div>)}
        <Button caption="Add new item" size="xs"
          on_click={()=>set_state(
            {...state,
              items: [...state.items, {question: '', answer: ''}]})}/>
      </Fragment>
    </Editor>;
};
